import { useEffect, useState } from "react";
import { InspectMode as InspectModeURL } from "../APIs/APIUrls";

const normalizeInspectMode = (data) => {



  if (typeof data === "boolean") {
    return data;
  }

  if (typeof data === "string") {
    const value = data.trim().toLowerCase();
    if (["true", "1", "yes", "on", "enabled", "enable"].includes(value)) {
      return true;
    }
    if (["false", "0", "no", "off", "disabled", "disable"].includes(value)) {
      return false;
    }
    return false;
  }

  if (data && typeof data === "object") {
    if (data.data.IsSwitch === true) {
      return true;
    }
    if (data.data.IsSwitch === false) {
      return false;
    }
    if (typeof data.IsSwitch === "boolean") {
      return data.IsSwitch;
    }
    if (typeof data.Value === "string") {
      const value = data.Value.trim().toLowerCase();
      if (["true", "1", "yes", "on", "enabled", "enable"].includes(value)) {
        return true;
      }
      if (["false", "0", "no", "off", "disabled", "disable"].includes(value)) {
        return false;
      }
    }
  }

  return false;
};

const DeveloperModeOnOff = () => {
  const [isInspectModeEnabled, setIsInspectModeEnabled] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const detectInspectMode = async () => {
      try {
        const response = await fetch(`${InspectModeURL}DetectInspectMode`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        });

        const text = await response.text();
        let payload = null;

        if (text) {
          try {
            payload = JSON.parse(text);
          } catch {
            payload = text;
          }
        }

        if (isMounted) {
          setIsInspectModeEnabled(normalizeInspectMode(payload));
        }
      } catch (error) {
        console.error("Inspect mode detection failed:", error);
        if (isMounted) {
          setIsInspectModeEnabled(false);
        }
      }
    };

    detectInspectMode();
    const intervalId = window.setInterval(detectInspectMode, 15000);

    return () => {
      isMounted = false;
      window.clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (
      typeof window === "undefined" ||
      typeof document === "undefined" ||
      !isInspectModeEnabled
    ) {
      return undefined;
    }

    const blockShortcut = (event) => {
      const key = event.key ? event.key.toLowerCase() : "";
      const code = event.code ? event.code.toLowerCase() : "";
      const isCtrlOrMeta = event.ctrlKey || event.metaKey;

      if (
        event.key === "F12" ||
        code === "f12" ||
        (event.altKey && key === "f12") ||
        (isCtrlOrMeta && event.shiftKey && (key === "i" || code === "keyi")) ||
        (isCtrlOrMeta && event.shiftKey && (key === "j" || code === "keyj")) ||
        (isCtrlOrMeta && event.shiftKey && (key === "c" || code === "keyc")) ||
        (isCtrlOrMeta && key === "u")
      ) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return false;
      }

      return true;
    };

    const blockContextMenu = (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      return false;
    };

    document.addEventListener("contextmenu", blockContextMenu, true);
    document.addEventListener("keydown", blockShortcut, true);
    document.addEventListener("keyup", blockShortcut, true);

    return () => {
      document.removeEventListener("contextmenu", blockContextMenu, true);
      document.removeEventListener("keydown", blockShortcut, true);
      document.removeEventListener("keyup", blockShortcut, true);
    };
  }, [isInspectModeEnabled]);

  return null;
};

export default DeveloperModeOnOff;
